export const contextTypeColorMap = {
  Product: 'primary-700',
  Finder: 'tertiary-600',
  Bidding: 'secondary-700',
  Default: 'text-orange-600',
}
